var $784ec4e789b99a71$exports = {};
$784ec4e789b99a71$exports = {
  "help": "\uB3C4\uC6C0\uB9D0",
  "info": "\uC815\uBCF4"
};
export { $784ec4e789b99a71$exports as default };